export default "__VITE_ASSET__Ckx8suC8__"